(function () {
    'use strict';

    angular
        .module('Lavpop-store.routes')
        .config(routes);

    /** @ngInject */
    function routes($stateProvider, $urlRouterProvider, $locationProvider, PATHS) {
        $locationProvider.html5Mode(true);
        $urlRouterProvider.otherwise('/not-found');

        $stateProvider
            .state('not-authorized', {
                title: 'Não Autorizado',
                url: '/not-authorized',
                templateUrl: `${PATHS.PHYSICAL}/components/not-authorized/not-authorized.html`,
                controller: 'NotAuthorizedController',
                controllerAs: 'vm'
            })

            .state('app', {
                abstract: true,
                templateUrl: `${PATHS.PHYSICAL}/components/layout/layout-default.html`,
                onEnter: ($q, $rootScope, AuthenticationService, HelperService, ProductService) => {
                    $rootScope.isOauth = false;

                    return $q.all([AuthenticationService.handleSystemLoad(), ProductService.configureProducts()])
                        .then(() => {
                            $rootScope.hideLoading = true;
                        }).catch(error => {
                            HelperService.handleStateChangeError(error);
                        });
                }
            })
            .state('app.not-found', {
                title: 'Não Autorizado',
                url: '/not-found',
                templateUrl: `${PATHS.PHYSICAL}/components/not-found/not-found.html`,
                controller: 'NotFoundController',
                controllerAs: 'vm'
            })
            .state('app.home', {
                title: 'Home',
                url: '/',
                templateUrl: `${PATHS.PHYSICAL}/components/home/home.html`,
                controller: 'HomeController',
                controllerAs: 'vm'
            })
            .state('app.products', {
                title: 'Produtos',
                url: '/products',
                templateUrl: `${PATHS.PHYSICAL}/components/products/products.html`,
                controller: 'ProductsController',
                controllerAs: 'vm'
            })
            .state('app.cart', {
                title: 'Minha Cesta',
                url: '/cart',
                templateUrl: `${PATHS.PHYSICAL}/components/cart/cart.html`,
                controller: 'CartController',
                controllerAs: 'vm'
            })
            .state('app.order-finalization', {
                title: 'Finalização de Pedido',
                url: '/order-finalization',
                templateUrl: `${PATHS.PHYSICAL}/components/order-finalization/order-finalization.html`,
                controller: 'OrderFinalizationController',
                controllerAs: 'vm'
            })
            .state('app.orders', {
                title: 'Meus Pedidos',
                url: '/orders',
                templateUrl: `${PATHS.PHYSICAL}/components/orders/orders.html`,
                controller: 'OrdersController',
                controllerAs: 'vm'
            })
            .state('app.orders-internal', {
                title: 'Ver Pedido',
                url: '/orders/{orderId:int}',
                templateUrl: `${PATHS.PHYSICAL}/components/orders/orders-internal.html`,
                controller: 'OrdersInternalController',
                controllerAs: 'vm'
            })
    }
}());